import React, {Component, Fragment} from "react";
import {connect} from "react-redux";
import {jwtDecode} from 'jwt-decode';
import {getAuthUrl} from "./store/actions/authTokenActions";
import {
    tokenInstance,
    logoutInstance
} from "./store/actions/userConfigActions";

import Index from "./components/index";
import PurchaseOrder from "./components/PurchaseOrder";
import PurchaseOrderDetail from "./components/PurchaseOrderDetail";
import {Router, Route, Switch, BrowserRouter} from "react-router-dom";
import {createBrowserHistory} from "history";
import Main from "./components/Main";
import ManageItemVendorInformationByDc
    from "./components/item_maintenance/manage_vendor_information_by_DC/ManageItemVendorInformationByDc";
import ManageItemForecastReplenishmentByDC
    from "./components/manage_forecast_replenishment/manage_item_forecast_replenishment_by_DC/ManageItemForecastReplenishmentByDC";
import ManageItemVolumetricInformationByDC
    from "./components/item_maintenance/Manage_item_volumetric_information_by_DC/ManageItemVolumetricInformationByDC";
import ItemInformationByDc from "./components/item_maintenance/Item_Information_By_Dc/ItemInformationByDc";
import {getAccessByHour} from "./actions";

import logoIcon from "./images/logo.png";
import ViewItemShipmentHistory from "./components/item_maintenance/ViewItemShipmentHistory/ViewItemShipmentHistory";
import ViewItemInformationItemLevel
    from "./components/item_maintenance/view_item_information_item_level/ViewItemInformationItemLevel";
import Spinner from "./components/common/Spinner";

import {getTokenInfo, testGet} from "./actions";
import ManageVendorForecastByDC
    from "./components/manage_forecast_replenishment/Manage_vendor_forecast_by_dc/ManageVendorForecastByDC";
import ManageVendorInformationByDc
    from "./components/vendor_maintenance/Manage_vendor_information_by_dc/ManageVendorInformationByDc";
import LookupVendorInformationByDcDiVendors
    from "./components/vendor_maintenance/Lookup_vendor_information_by_dc_di_vendors/LookupVendorInformationByDcDiVendors";
import LookupVendorInformationByNumber
    from "./components/vendor_maintenance/Lookup_vendor_information_by_number/LookupVendorInformationByNumber";
import ViewDiYardManagementeSystemTracking
    from "./components/yard_management/di_yard_management_system_tracking/ViewDiYardManagementeSystemTracking";
import LookupVendorLevelInformation
    from "./components/vendor_maintenance/Lookup_vendor_level_information/LookupVendorLevelInformation";
import AltVendor from './extension/pages/alt-vendor/index';
import MOQMaintenance from './extension/pages/moq-maintenance/index';
import ASN from './extension/pages/override-asn/index';

class App extends Component {
    state = {};

    constructor(props) {
        super(props);
        this.state = {
            secretcode: "",
            isLoggedIn: false,
            openModal: false,
            loginDetails: sessionStorage.getItem("loginDetails"),
            accessHours: {messages: [""]},
            tokenName: ""
        };

        if (window.location.href.split("/?")[1] === undefined) {
            this.getUserConfig();
            if (sessionStorage.getItem("loginDetails") == null) {
                window.location = window.env.REDIRECT_URI;
            }
            console.log("commented block");
        } else if (window.location.href.split("/?")[1].split("=")[0] === "code") {
            let params = this.getParams(window.location.href);
            params.code = params.code.substring(0, params.code.length);
            sessionStorage.setItem("code", params.code);
            if (params.code === undefined || params.code === "") {
                this.getUserConfig();
            } else if (sessionStorage.getItem("loginDetails") === null) {
                this.callTokenAPI("authorization_code", params.code);
            }
        }
    }

    getParams(url) {
        var params = {};
        var parser = document.createElement("a");
        parser.href = url;
        var query = url.split("/?")[1];
        if (query !== "" && query !== undefined) {
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                params[pair[0]] = decodeURIComponent(pair[1]);
            }
        }
        return params;
    }

    callTokenAPI(grant_type, res_code) {
        this.props
            .tokenInstance(grant_type, res_code)
            .then(res => {
                sessionStorage.setItem(
                    "loginDetails",
                    JSON.stringify(this.props.userConfigs)
                );
                this.setState({
                    loginDetails: sessionStorage.getItem("loginDetails")
                });
                getAccessByHour().then(res => {
                    this.setState({accessHours: res.data});
                });
                getTokenInfo()
                    .then(res => {
                        if (res.status === 200) {
                            const userInfo = this.getNameAndUidFromToken();
                            const uId = userInfo.uid;
                            this.setState({tokenName: userInfo.name });
                            sessionStorage.setItem("tokenName", userInfo.name);
                            sessionStorage.setItem("uId", uId);
                        } else {
                            sessionStorage.setItem("uId", "30081044");
                        }
                    })
                    .catch(error => {
                        sessionStorage.setItem("uId", "30081044");
                    });
            })
            .catch(error => {
            });
    }

    componentDidMount() {
        this.setState({
            secretcode: window.env.TEST_CODE
        });
        if (sessionStorage.getItem("tokenName")) this.setState({tokenName: sessionStorage.getItem("tokenName")});
    }

    handleModalAction = () => {
        this.setState({openModal: !this.state.openModal});
    };
    handleCancel = () => {
        this.setState({openModal: !this.state.openModal});
    };
    handleOk = () => {
        this.setState({openModal: !this.state.openModal});
    };

    getUserConfig(e) {
        this.setState({isLoggedIn: !this.state.isLoggedIn});
        this.props.getAuthUrl(e).then(res => {
            this.setState({
                loginURL: this.props.loginURL
            });
            window.location = this.state.loginURL;
        });
    }


    clearCookie = (name, domain, path) => {
        var domain = domain || document.domain;
        var path = path || "/";
        document.cookie =
            name +
            "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" +
            "; domain=" +
            domain +
            "; path=" +
            path +
            "; SameSite=None; Secure";
    };

    logOut() {
        this.props.logoutInstance().then(res => {
            this.setState({
                revokeToken: this.props.revokeToken
            });
            sessionStorage.clear();
            sessionStorage.removeItem("loginDetails");
            localStorage.clear();
            localStorage.removeItem("challenge");
            this.clearCookie("AZAuthTest", ".autozone.com", "/");
            this.setState({isLoggedIn: false});

            window.location.href =  window.env.REDIRECT_LOGOUT_URL;

        });
    }

    getNameAndUidFromToken() {
        const loginDetails = JSON.parse(sessionStorage.getItem("loginDetails"));

        if (!loginDetails || !loginDetails.access_token) {
            console.error("No access token found in loginDetails");
            return null;
        }

        try {
            const decodedToken = jwtDecode(loginDetails.access_token);
            const name = decodedToken.givenName + " " + decodedToken.sn;
            const uid = decodedToken.sub;
            //console.log("Name:", name);
            //console.log("UID:", uid);
            return {name, uid};
        } catch (error) {
            console.error("Error decoding access token:", error);
            return null;
        }
    }


    handleSettings(e) {
        if (e === "toggleTooltip") {
            this.state.settings.tooltips
                ? this.setState({settings: {tooltips: false}})
                : this.setState({settings: {tooltips: true}});
        }
    }


    render() {
        //return true ? (
        return this.state.accessHours ? (
                <BrowserRouter
                    basename={window.env.BASE_NAME}
                >
                    <Fragment>
                        <div className="header">
                            <div className="header-container">
                                <img className="header-image" src={logoIcon} alt="AutoZone"/>
                                <div className="user-options">
                                    <div className="logoutNameContainer">
                                        <p className="logoutName">{this.state.tokenName}</p>
                                        <div>
                                            <i className="material-icons user-options-icon">person</i>
                                            <div className="user-options-menu">
                                                <div onClick={() => this.logOut()} className="user-options-menu-item">
                                                    <i className="material-icons">exit_to_app</i>Log out
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content-body">
                            <Main user=""/>
                            <Switch>
                                <Route path="/" exact component={Index}/>
                                <Route path="/poheader" exact component={PurchaseOrder}/>
                                <Route path="/podetail" component={PurchaseOrderDetail}/>
                                <Route
                                    path="/item_maintenance/manage_item-vendor_information_by_dc"
                                    component={ManageItemVendorInformationByDc}
                                />
                                <Route
                                    path="/item_maintenance/manage_item_information_by_dc"
                                    component={ItemInformationByDc}
                                />
                                <Route
                                    path="/manage_forecast_replenishment/manage_item_forecast_replenishment_by_dc"
                                    component={ManageItemForecastReplenishmentByDC}
                                />
                                <Route
                                    path="/item_maintenance/manage_item_volumetric_information_by_dc"
                                    component={ManageItemVolumetricInformationByDC}
                                />
                                <Route
                                    path="/vendor_maintenance/manage_vendor_information_by_dc"
                                    component={ManageVendorInformationByDc}
                                />
                                <Route
                                    path="/vendor_maintenance/view_vendor_information_by_dc_di_vendors"
                                    component={LookupVendorInformationByDcDiVendors}
                                />
                                <Route
                                    path="/vendor_maintenance/view_vendor_information_by_number"
                                    component={LookupVendorInformationByNumber}
                                />
                                <Route
                                    path="/item_maintenance/view_item_shipment_history_by_dc"
                                    component={ViewItemShipmentHistory}
                                />
                                <Route
                                    path="/manage_forecast_replenishment/manage_vendor_forecast_replenishment_by_dc"
                                    component={ManageVendorForecastByDC}
                                />
                                <Route
                                    path="/yard_management/view_di_yard_management"
                                    component={ViewDiYardManagementeSystemTracking}
                                />
                                <Route
                                    path="/item_maintenance/view_item_information_item_level"
                                    component={ViewItemInformationItemLevel}
                                />
                                <Route
                                    path="/item_maintenance/view_vendor_level_information_by_number"
                                    component={LookupVendorLevelInformation}
                                />
                                <Route
                                    path="/item_maintenance/view_vendor_level_information_by_name"
                                    component={LookupVendorLevelInformation}
                                />
                                <Route
                                    path="/alternate_vendor/view_alternate_vendor"
                                    component={AltVendor}
                                />
                                <Route
                                    path="/moq_maintenance/view_moq_maintenance"
                                    component={MOQMaintenance}
                                />
                                <Route
                                    path="/override_asn/view_override_asn"
                                    component={ASN}
                                />
                            </Switch>
                        </div>
                        <div className="copyright">
                            <p>
                                <a href="https://www.autozone.com/company/terms/rules-reg.html">
                                    ©2022 AutoZone, Inc. All rights reserved.
                                </a>
                            </p>
                            <p>R 3.2</p>
                        </div>
                    </Fragment>
                </BrowserRouter>
            )
            : (
                <div className="fullScreenNotification">
                    <Spinner msg="Loading..." wheelColor="rgba(0,0,0,.75)"/>
                </div>
            );
    }
}

const mapStateToProps = ({loginUrl, userConfigs}) => {
    return {
        loginURL: loginUrl.loginurl,
        userConfigs: userConfigs.tokenInstance,
        revokeToken: userConfigs.revokeInstance
    };
};

export default connect(
    mapStateToProps,
    {getAuthUrl, tokenInstance, logoutInstance}
)(App);
